
import { ApolloError } from '@apollo/client';
import { GraphQLError } from 'graphql';
import { EDTypography } from '../../BaseComponents/Typography/EDTypography';
import { getRootPath } from '../AppNavbar/Components/UserMenu/Components/LogoutHandler';
import ServerErrorView from './ServerErrorView';
import ServerErrorSimple from './ServerErrorSimple';
import { InternalError } from '../InternalError/InternalError';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

interface IProps {
  error: ApolloError;
  associationName?: string;
  caption?: string;
}
const useStyles = makeStyles()((theme: Theme) => ({
  errorColumn: {
    width: '100%',
    maxWidth: '800px',
    display: 'inline-block',
    overflowWrap: 'break-word',
    fontStyle: 'italic',
  },
  errorViewContainer: {
    margin: `${theme.spacing(2)} 0`,
  },
}));

/**
 * Om felkoden är en av dessa så ska inloggningsstatus uppdateras
 */
export const isLoggedInError = (error: GraphQLError) =>
  error.extensions?.ExceptionClass === 'EDBackendVersionError' ||
  error.extensions?.ExceptionClass === 'EDLoginRequired';

export const redirectToLogin = () => {
  location.replace(getRootPath(location.href));
};

/**
 * Komponenten ska visa fel från apollo-klienten
 */
export const ServerError: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { graphQLErrors, networkError } = props.error;
  const { classes } = useStyles();
  return props.caption ? (
    <ServerErrorSimple
      errors={graphQLErrors}
      caption={props.caption}
      errorMessage={props.error.message}
    />
  ) : (
    <InternalError
      message={''}
      id={'f6d70173-f9b8-449a-991e-39e63b34f5bd'}
      error={props.error}
      skipErrorLogging
    >
      <div className={classes.errorColumn}>
        <EDTypography variant="subtitle1">
          Fel vid kontakt med servern
        </EDTypography>
        <EDTypography>{props.error.message}</EDTypography>
        {graphQLErrors &&
          graphQLErrors.map((error, i) => (
            <div key={i} className={classes.errorViewContainer}>
              <ServerErrorView error={error} key={i} />
            </div>
          ))}
        {networkError && (
          <EDTypography label={networkError.message}>
            <EDTypography>Nätverksfel, mer info!</EDTypography>
          </EDTypography>
        )}
      </div>
    </InternalError>
  );
};

export default ServerError;
